import { snakeCase } from 'lodash/fp';

import {
  CaseDataManagerCriteriaVariableKeys,
  CaseDataManagerCriteriaVariableSchemas,
  CaseDataManagerSchema,
} from 'dashboard/models/case-template';
import { FieldSchema } from 'lib/fields';

export const getCaseDataManagerSchema = (
  caseDataManagerSchema: CaseDataManagerCriteriaVariableSchemas,
): CaseDataManagerSchema => {
  const generatedSchema: CaseDataManagerSchema = {
    current_case: getCaseObjectCriteriaVariableSchema('case', caseDataManagerSchema),
    current_user: getCaseObjectCriteriaVariableSchema('current-user', caseDataManagerSchema),
  };

  return generatedSchema;
};

/* TODO: (melissa) make an actual fix for this and think about it more...
 * Right now, the issue is that the case data manager response is coming back to us as
 *   {
 *     case: {
 *       common: { fields: { ... }, ...},
 *       'with-template': {},
 *     },
 *     ...,
 *   }
 *
 * We need to combine the returns from 'common' and 'with-template' to flatten the
 * response so that it looks like what the modules will see at runtime.
 */
export const getCaseObjectCriteriaVariableSchema = (
  objectKey: CaseDataManagerCriteriaVariableKeys,
  caseDataManagerSchema: CaseDataManagerCriteriaVariableSchemas,
): Partial<Record<string, FieldSchema>> => {
  // For now, we only use commonSchemas in cases. When we add 'with-template' schemas, we'll
  // need to update this method.
  const commonSchemas = caseDataManagerSchema[objectKey]?.common || {};

  // snake_case keys until we start sending snake_case keys from the backend. Variables/caseDatManager should not be key inflected.
  return Object.fromEntries(
    Object.entries(commonSchemas).map(([key, value]) => [snakeCase(key), value]),
  );
};
